export default function initializeSingleProduct() {
    initializeReviewsForm();
    initializeScrollCollapseTabs();
}

function initializeReviewsForm() {
    let commentsForm = document.querySelectorAll('#commentform');

    if (!commentsForm) {
        return;
    }

    commentsForm.forEach(function (form) {
        let formButton = form.querySelector('#submit');
        let formComment = form.querySelector('#comment');

        if (formButton && formComment) {
            formButton.addEventListener('click', function (e) {
                if (formComment.value.length < 5) {
                    alert('Treść komentarza jest zbyt krótka');
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }
    });
}

function initializeScrollCollapseTabs() {
    document.querySelectorAll('.single-product-container__tab-content ')?.forEach(function (item) {
        console.log(item);
        // Listen for shown.bs.collapse event. Different from show.bs.collapse
        // Needs to be shown.bs.collapse otherwise the item has no height.
        item.addEventListener('shown.bs.collapse', function () {
            console.log('shown.bs.collapse');
            // Get the height of the item content
            var itemHeight = this.scrollHeight;

            // jeśli tytuł jest wyżej niż górna krawędź ekranu
            if (this.getBoundingClientRect().top < 0) {
                // scroll na element, ale z marginesem 100px
                window.scrollTo({
                    top: this.getBoundingClientRect().top + window.scrollY - 200,
                    behavior: 'smooth'
                });
            }

        });
    });
}